import { Stack, Box } from "@mui/material";
import { useRecoilState, useRecoilValue } from "recoil";
import { kakaoState } from "recoil/kakaoState";
import { authState } from "../recoil/authState";
import { 
  CalendarToday, 
  CalendarMonth, 
  LocalOffer, 
  AccessTime, 
  SportsGolf,
  AccountBox
} from "@mui/icons-material";

const useNavData = () => {
  const auth = useRecoilValue(authState);
  const clubAdminLevel = auth?.user?.club_admin_level;

  const navData = [
    {
      key: "yb",
      name: "연 단체 예약",
      icon: <CalendarToday />,
      isTopParent: true,
      child: [
        {
          key: "yearBookingList",
          isMenuItem: true,
          name: "신청내역",
          child: [{ key: ":id", name: "신청상세" }],
        },
        {
          key: "yearBookingRoundingList",
          isMenuItem: true,
          name: "예약내역",
          child: [{ key: ":id", name: "예약상세" }],
        },
        // club_admin_level === 9(SBS)가 아닐 때 단체관리 표시
        ...(() => {
          const shouldShowGroups = Number(clubAdminLevel) !== 9;
          return shouldShowGroups
            ? [
                {
                  key: "yearBookingGroups",
                  isMenuItem: true,
                  name: "단체관리",
                  child: [{ key: ":id", name: "단체상세" }],
                },
              ]
            : [];
        })(),
      ],
    },
    // club_admin_level === 9일 때는 월단체 부킹 숨김
    ...(() => {
      const shouldShowEventBooking = Number(clubAdminLevel) !== 9;
      return shouldShowEventBooking
        ? [
            {
              key: "eb",
              name: "월 단체 예약",
              icon: <CalendarMonth />,
              isTopParent: true,
              child: [
                {
                  key: "eventBookingList",
                  isMenuItem: true,
                  name: "신청내역",
                  child: [{ key: ":id", name: "신청상세" }],
                },
                {
                  key: "eventBookingRoundingList",
                  isMenuItem: true,
                  name: "예약내역",
                  child: [{ key: ":id", name: "예약상세" }],
                },
              ],
            },
          ]
        : [];
    })(),

    // club_admin_level === 10일 때만 할인 부킹 표시
    ...(() => {
      const shouldShowDiscountBooking = Number(clubAdminLevel) === 10;
      return shouldShowDiscountBooking
        ? [
            {
              key: "dc",
              isTopParent: true,
              name: "할인 예약",
              icon: <LocalOffer />,
              child: [
                {
                  key: "bookingdiscountList",
                  name: "할인부킹 관리",

                  isMenuItem: true,
                  child: [
                    {
                      key: "create",
                      name: "할인부킹 등록",
                      child: [{ key: ":id", name: "상세" }],
                    },
                  ],
                },
                {
                  key: "bookingdiscountrsvps",
                  name: "할인부킹 예약 관리",
                  isMenuItem: true,

                  child: [],
                },
              ],
            },
          ]
        : [];
    })(),
    {
      key: "erp",
      isTopParent: true,
      name: "실시간 예약",
      icon: <AccessTime />,
      child: [
        {
          key: "erpBookingList",
          name: "예약내역",
          isMenuItem: true,
          child: [{ key: ":id", name: "예약상세" }],
        },
      ],
    },
    // club_admin_level === 9일 때는 골프장 서비스 숨김
    ...(() => {
      const shouldShowGolfService = Number(clubAdminLevel) !== 9;
      return shouldShowGolfService
        ? [
            {
              key: "golfservice",
              name: "골프장 서비스",
              icon: <SportsGolf />,
              isTopParent: true,
              child: [
                {
                  key: "golfinfo",
                  name: "골프장 관리",
                  path: "common/golfinfo",
                  child: [
                    {
                      key: "modify",
                      name: "정보 수정",
                      path: "common/golfinfo/modify",
                      child: [{ key: ":id", name: "골프장 정보" }],
                    },
                  ],
                  isMenuItem: true,
                },
                {
                  key: "golfacount",
                  name: "골프장 계정관리",
                  path: "common/golfacount",
                  child: [],
                  isMenuItem: true,
                },
              ],
            },
          ]
        : [];
    })(),
  ];

  return navData;
};

const useBottomNavData = () => {
  const [Kakao] = useRecoilState(kakaoState);
  const auth = useRecoilValue(authState);
  const clubAdminLevel = Number(auth?.user?.club_admin_level);

  const bottomNavData = [
    {
      key: "common",
      name: "일반",
      child: [
        // club_admin_level === 9일 때는 이용문의 숨김
        ...(() => {
          const shouldShowChat = Number(clubAdminLevel) !== 9;
          return shouldShowChat
            ? [
                {
                  key: "chat",
                  name: (
                    <Stack
                      flexDirection={"row"}
                      alignItems={"center"}
                      gap={1}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Box
                        sx={{
                          width: "24px",
                          height: "24px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <img 
                          src="/kakao.png" 
                          alt="카카오톡 문의"
                          style={{
                            width: "20px",
                            height: "20px",
                            objectFit: "contain",
                            display: "block",
                          }}
                        />
                      </Box>
                      카카오톡 문의
                    </Stack>
                  ),
                  isBtn: true,
                  onClick: () => {
                    // alert('hi');
                    Kakao.teeshot.chat();
                  },
                  child: [],
                  isMenuItem: true,
                },
              ]
            : [];
        })(),
        {
          key: "logList",
          name: (
            <Stack
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  width: "24px",
                  height: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <AccountBox 
                  sx={{
                    fontSize: "24px",
                    width: "24px",
                    height: "24px",
                    color: "white",
                    display: "block",
                  }}
                />
              </Box>
              회원 접속로그
            </Stack>
          ),
          child: [],
          requiresMasterAuth: true,
          isMenuItem: true,
        },
      ],
    },
  ];

  return bottomNavData;
};

export { useNavData, useBottomNavData };
